import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Mitarbeiter as MitarbeiterType } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';

export function Mitarbeiter({ mitarbeiter }: { mitarbeiter: MitarbeiterType }) {
  const initials =
    mitarbeiter.vorname[0].toUpperCase() +
    mitarbeiter.nachname[0].toUpperCase();

  return (
    <div className="sticky left-0 z-10 flex gap-2 border-r border-solid border-neutrals-N200 p-1 bg-white">
      <Avatar>
        {mitarbeiter.imgUrl ? (
          <AvatarImage
            alt={mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
            src={mitarbeiter.imgUrl}
          />
        ) : (
          <AvatarFallback>{initials}</AvatarFallback>
        )}
      </Avatar>
      <div className="hidden md:flex md:flex-col min-w-0">
        <div className="text-sm text-neutrals-N900 truncate">
          {mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
        </div>
        <div className="text-xs text-neutrals-N700">
          {mitarbeiter.lehrjahr + '⋅' + mitarbeiter.beruf.abkuerzung}
        </div>
      </div>
    </div>
  );
}
